import HTMLReactParser from "html-react-parser"
import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import SwiperNavigation from "@components/global/SwiperNavigation"
import { dataLayerFoodBeverages } from "lib/datalayer"
import { linkProductsServicesConcession } from "src/helper/page-url"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, imgUrl } from "src/mixins"

function ProductsServicesConcession({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  return (
    <section className="sc-products-services-concession" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row title-row mx-0 justify-content-between align-items-center">
            <div>
              <h1 className={`title ${anim(1)}`}>
                {data && data[`title_${locale}`]}
              </h1>
              <div className={`text ${anim(2)}`}>
                {convertHtmlToReact(data[`description_${locale}`])}
              </div>
            </div>
            <SwiperNavigation
              handlePrev={handlePrev}
              handleNext={handleNext}
              theme="dark"
            />
          </div>
          <SliderSwiper
            loop={false}
            swiperRef={swiperRef}
            breakpoints={{
              640: {
                slidesPerView: 1.6,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 3.2,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 4.2,
                spaceBetween: 15,
              },
            }}
            className="concession-slider mt-4"
          >
            {data?.concessions?.map((item, i) => (
              <SwiperSlide key={`concession-${i}`}>
                <div
                  role="presentation"
                  onClick={() =>
                    dataLayerFoodBeverages({
                      food_stand_name: item[`title_${locale}`],
                    })
                  }
                >
                  <Card
                    link={`${linkProductsServicesConcession}/${item.slug}`}
                    img={imgUrl(item?.thumb_image)}
                    variant="overlay"
                    imgRatio="r-3-4"
                    title={item[`title_${locale}`]}
                    titleClassName="h-50px"
                    className={anim(i + 3)}
                  />
                </div>
              </SwiperSlide>
            ))}
          </SliderSwiper>
        </div>
      </div>
    </section>
  )
}

export default ProductsServicesConcession
